import React from 'react'
import footerlogo from "../../images/footerlogo.png"
import '../footer/footer.css'
import { FaFacebookF, FaLinkedinIn } from 'react-icons/fa6'
function footer() {
    return (
        <footer>
            <div className="footer-inner">
                <div className="left">
                    <div className="footerlogo">
                        <img src={footerlogo} alt="" />
                        <span>
                            <strong>Arttteo</strong>
                            <p>Software Development</p>
                        </span>
                    </div>
                    <p>Our specialized expertise shines through a cadre of elite professionals, each with a remarkable history of collaboration with renowned global brands, ensuring exceptional results and unparalleled quality in every endeavor.</p>
                    <ul className="social">
                        <a href="https://www.linkedin.com/company/arttteo/posts/?feedView=all"><li><FaLinkedinIn /></li></a>
                        <a href="https://www.facebook.com/arttteosoftware"><li><FaFacebookF /></li></a>
                    </ul>
                </div>
                <div className="right">
                    <ul>
                        <p className='footerlink-title'>Navigation</p>
                        <li><a href="https://arttteo.com/portfolios">Our Works</a></li>
                        <li><a href="https://arttteo.com/blogs">Blog</a></li>
                        <li><a href="https://arttteo.com/contact">Contact</a></li>
                    </ul>
                    <ul>
                        <p className='footerlink-title'>Services</p>
                        <li><a href="https://arttteo.com/services/augmented-reality">Augmented reality</a></li>
                        <li><a href="https://arttteo.com/services/virtual-reality">Virtual Reality</a></li>
                        <li><a href="https://arttteo.com/services/outsourcing">Outsourcing</a></li>
                        <li><a href="https://arttteo.com/services/staff-augmentation">Staff Augmentation</a></li>
                        <li><a href="https://arttteo.com/services/machine-learning">AI and Machine Learning</a></li>
                    </ul>
                    <ul>
                        <p className='footerlink-title'>Expertise</p>
                        <li><a href="https://arttteo.com/expertise/for-startup">For Startup</a></li>
                        <li><a href="https://arttteo.com/expertise/for-investors">For Agencies</a></li>
                        <li><a href="https://arttteo.com/expertise/for-programs">For SME</a></li>
                    </ul>
                    <ul>
                        <p className='footerlink-title'>Social Media</p>
                        <li><a href="https://www.facebook.com/arttteosoftware">Facebook </a></li>
                        <li><a href="https://www.linkedin.com/company/arttteo/mycompany/">Linkedin</a></li>
                    </ul>
                </div>
            </div>
            <div className="terms-conditions">
                <p>© Arttteo 2025</p>
                {/* <div className="t-c">
                    <p>Terms and Conditions</p>
                    <span>·</span>
                    <p>Privacy Policy</p>
                </div> */}
            </div>
        </footer>
    )
}

export default footer